import React from 'react'
import { useNavigate } from 'react-router-dom'

export const CTA_WhoWeAre = () => {
  const navigate = useNavigate()

  return (
    <div className='flex flex-col justify-center items-center text-center py-16'>
      <h1 className='text-slate-900 sm:text-4xl text-sm font-bold'>
        To take the stress, time and risk out of finding the right lawyer
      </h1>
      <button
        onClick={() => {
          window.scrollTo(0, 0)
          navigate('/our-mission')
        }}
        className='h-11 !px-4 py-3 bg-indigo-950 text-white rounded-lg shadow-[0px_1px_4px_0px_rgba(0,0,0,0.25)] sm:mt-12 sm:mb-36 mb-18 mt-6 sm:text-base text-xs'
      >
        Our mission
      </button>
    </div>
  )
}
